import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {

  return originalPush.call(this, location).catch(err => err)

}

Vue.use(VueRouter)
const HomePage = () => import('@/views/HomePage')


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/login',
      component: () => import('@/views/login/index')
    },{
      path: '/',
      meta:{
        requireAuth:false
      },
      component: HomePage
    },
    {
      path:'/service',
      meta:{
        requireAuth:false
      },
      component: () => import('@/views/ServicePage')
    },
    {
      path:'/details',
      meta:{
        requireAuth:false
      },
      component: () => import('@/views/DetailsPage')
    },
    {
      path:'/plan',
      meta:{
        requireAuth:false
      },
      component: () => import('@/views/PlanPage')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js